export default __webpack_public_path__ + "static/zuzana-320af94a195dd3226cfa2acff517c553.jpg";